/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lot_History_Col_QuantityInputs */

const vi_sl_lot_history_col_quantity = /** @type {(inputs: Sl_Lot_History_Col_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng`)
};

/**

* @param {Sl_Lot_History_Col_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_history_col_quantity = /** @type {((inputs?: Sl_Lot_History_Col_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_History_Col_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_history_col_quantity(inputs)
});